import React, { Component } from "react";
import { Link } from "gatsby";
import queryString from "query-string";
import { getRef } from "../../helpers/utils";

// sub-components
import Contain from "../contain";

// assets
import logo from "../../images/logo-re.svg";
import logoSticky from "../../images/logo-sticky.svg";
import icon from "../../images/icon-qp.svg";

import {
  HeaderSection,
  Logo,
  Menu,
  ButtonCTA,
  ButtonMenu,
  MobileMenu,
} from "./styles";

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

class Header extends Component {
  state = {
    sticky: false,
    isMenuOpen: false,
    registerUrl:
      "https://quickpageapp.com/register?p=plan_HBi0YdaHYZYTWP&qpc=kwrur&qp_i=real-estate&qp_hau=kwrur",
    width: null,
  };

  scrollHandler = () => {
    let sticky = false;
    const body = document.body;

    if (window.pageYOffset > window.innerHeight) {
      sticky = true;
      body.classList.add("sticky-header");
    } else {
      sticky = false;
      body.classList.remove("sticky-header");
    }

    this.setState({ sticky });
  };

  scrollToPricing = (e) => {
    e.preventDefault();
    document.getElementById("pricing").scrollIntoView({
      behavior: "smooth",
    });
  };

  componentDidMount() {
    window.addEventListener("scroll", debounce(this.scrollHandler, 16));
    this.setState({ width: window.innerWidth });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", debounce(this.scrollHandler, 16));
  }

  renderMenuMobile() {
    return (
      <MobileMenu>
        <Link to="#" onClick={this.scrollToPricing}>
          Pricing
        </Link>
        <a href="https://quickpageapp.com/sign-in">Sign In</a>
      </MobileMenu>
    );
  }

  render() {
    const { sticky, width } = this.state;
    const mobile = width < 680;
    const logoImg = mobile ? icon : sticky ? logoSticky : logo;
    return (
      <HeaderSection sticky={sticky}>
        <Contain flexCenterBetween fullWidth>
          <Logo>
            <Link to="/">
              <img src={logoImg} alt="Quickpage" />
            </Link>
          </Logo>
          <Menu>
            <Link to="#" onClick={this.scrollToPricing}>
              Pricing
            </Link>
            <a href="https://quickpageapp.com/sign-in" className="hm">
              Sign In
            </a>
            <ButtonCTA href={this.state.registerUrl}>Get started now</ButtonCTA>
            <ButtonMenu
              onClick={() =>
                this.setState({ isMenuOpen: !this.state.isMenuOpen })
              }
              isMenuOpen={this.state.isMenuOpen}
            ></ButtonMenu>
          </Menu>
        </Contain>
        {this.state.isMenuOpen && this.renderMenuMobile()}
      </HeaderSection>
    );
  }
}

export default Header;
